export enum TariffRouteName {
    Index = 'tariffs.index',
    Create = 'tariffs.create',
    Edit = 'tariffs.edit',
    Clone = 'tariffs.clone',
    RegexesIndex = 'tariffs.regexes.index',
    RegexesCreate = 'tariffs.regexes.create',
    RegexesEdit = 'tariffs.regexes.edit',
    RegexesDetails = 'tariffs.regexes.details',
    Items = 'tariffs.items',
    ItemCreate = 'tariffs.items.create',
    ItemEdit = 'tariffs.items.edit',
}

export default {
    path: 'tariffs',
    component: () => import('./pages/wrapper.vue'),
    children: [
        {
            path: '',
            name: TariffRouteName.Index,
            component: () => import('./pages/index.vue'),
            meta: {
                label: 'Tariffs',
                icon: 'fal fa-puzzle-piece fa-fw',
                location: 'sidebar',
                permission: 'manage-tariffs',
                auth: true,
                group: 'main',
            },
        },
        {
            path: 'create',
            name: TariffRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Tariff',
                permission: 'manage-tariffs',
                group: 'main',
            },
        },
        {
            path: ':tariffId/items',
            name: TariffRouteName.Items,
            component: () => import('./pages/items.vue'),
            meta: {
                auth: true,
                label: 'Tariff Items',
                permission: 'manage-tariffs',
                group: 'main',
            },
            children: [
                {
                    path: 'create',
                    name: TariffRouteName.ItemCreate,
                    component: () => import('./pages/items.vue'),
                    meta: {
                        auth: true,
                        label: 'Create Tariff Item',
                        permission: 'manage-tariffs',
                        group: 'main',
                    },
                },
                {
                    path: ':tariffItemId?/edit',
                    name: TariffRouteName.ItemEdit,
                    component: () => import('./pages/items.vue'),
                    meta: {
                        auth: true,
                        label: 'Edit Tariff Item',
                        permission: 'manage-tariffs',
                        group: 'main',
                    },
                },
            ],
        },
        {
            path: ':tariffId/edit',
            name: TariffRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Tariff',
                permission: 'manage-tariffs',
                group: 'main',
            },
        },
        {
            path: ':tariffId/clone',
            name: TariffRouteName.Clone,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Clone Tariff',
                permission: 'manage-tariffs',
                group: 'main',
            },
        },
        {
            path: ':tariffId?/regexes',
            name: TariffRouteName.RegexesIndex,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Tariff Regexes',
                permission: 'manage-tariffs',
                group: 'main',
            },
            children: [
                {
                    path: 'create',
                    name: TariffRouteName.RegexesCreate,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Create Tariff Regex',
                        permission: 'manage-tariffs',
                        group: 'main',
                    },
                },
                {
                    path: ':tariffRegexId/edit',
                    name: TariffRouteName.RegexesEdit,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Edit Tariff Regex',
                        permission: 'manage-tariffs',
                        group: 'main',
                    },
                },
                {
                    path: ':tariffRegexId/details',
                    name: TariffRouteName.RegexesDetails,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Tariff Regex Details',
                        permission: 'manage-tariffs',
                        group: 'main',
                    },
                },
            ],
        },
    ],
}
